(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__productTabsSectionBound) return;
    window.__productTabsSectionBound = true;

    function renderVideo(scope) {
      const root = scope || document;
      root.querySelectorAll('.video-open-popup:not([data-video-bound])').forEach((videoOpenPopup) => {
        videoOpenPopup.dataset.videoBound = 'true';
        videoOpenPopup.addEventListener('click', function (e) {
          e.preventDefault();
          const videoId = videoOpenPopup.dataset.videoId;
          const videoWrapper = document.querySelector('.video-modal__content-block');
          if (!videoWrapper || !videoId) return;
          videoWrapper.innerHTML = `<iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
        });
      });
    }

    function ensureVideoModal() {
      if (document.getElementById('PopupModal-product-tabs-video')) return;
      document.body.insertAdjacentHTML(
        'beforeend',
        `<side-drawer class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden" id="PopupModal-product-tabs-video" data-moved="true">
          <div class="drawer__overlay fixed inset-0 cursor-pointer"></div>
          <div class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup">
            <div class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar">
              <div class="video-modal__content-block">Video</div>
              <button onclick="this.closest('side-drawer').close()" class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute" type="button" aria-label="Close dialog" style="--top: 0.3rem; --right: 0.3rem">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg>
              </button>
            </div>
          </div>
        </side-drawer>`
      );
    }

    function openAccordionTab(tabContent) {
      const section = tabContent.closest('.section-product-tabs');
      if (!section) return;
      section.querySelectorAll('.style-accordion .toggle-title.is-open').forEach((el) => el.classList.remove('is-open'));
      tabContent.querySelector('.toggle-title')?.classList.add('is-open');
    }

    function closeAccordionTab(tabContent) {
      tabContent.querySelector('.toggle-title')?.classList.remove('is-open');
    }

    document.addEventListener('click', function (e) {
      const section = e.target.closest('.section-product-tabs');
      if (!section) return;

      const tabTitle = e.target.closest('.tab-title');
      if (tabTitle && section.contains(tabTitle)) {
        e.preventDefault();
        const tabList = section.querySelector('.tabs-list');
        if (!tabList) return;
        const tabTitles = [...tabList.querySelectorAll('.tab-title')];
        const tabContents = [...section.querySelectorAll('.product-tabs-tab .tabs-content > .tab-content')];
        const index = tabTitles.indexOf(tabTitle);
        if (index === -1 || tabTitle.classList.contains('is-active')) return;
        tabTitles.forEach((t) => t.classList.remove('is-active'));
        tabContents.forEach((c) => c.classList.remove('is-active'));
        tabTitle.classList.add('is-active');
        setTimeout(() => {
          const content = tabContents[index];
          if (!content) return;
          content.classList.add('is-animating', 'is-active');
          content.addEventListener(
            'transitionend',
            function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            },
            { once: true }
          );
        }, 10);
        return;
      }

      const toggleLink = e.target.closest('.toggle-link');
      if (!toggleLink || !section.contains(toggleLink)) return;
      e.preventDefault();

      const toggleTitle = toggleLink.closest('.toggle-title');
      if (!toggleTitle) return;

      const tabTitleText = document.querySelector('.tab-title-text');
      if (tabTitleText) tabTitleText.textContent = toggleLink.textContent;

      const viewContentType = toggleTitle.dataset.viewContent;
      const content = toggleTitle.nextElementSibling;
      if (!content) return;

      if (Shopify?.designMode && section.querySelector('.style-accordion')) return;

      switch (viewContentType) {
        case 'sidebar': {
          const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
          if (drawerContent) {
            drawerContent.innerHTML = '';
            drawerContent.appendChild(content.cloneNode(true));
            renderVideo(drawerContent);
          }
          break;
        }
        case 'popup': {
          const popupContent = document.querySelector('.popup-content-wrapper');
          if (popupContent) {
            popupContent.innerHTML = '';
            popupContent.appendChild(content.cloneNode(true));
            renderVideo(popupContent);
          }
          break;
        }
        default:
          toggleTitle.classList.toggle('is-open');
      }
    });

    if (Shopify?.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        openAccordionTab(tabContent);
      });

      document.addEventListener('shopify:block:deselect', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        closeAccordionTab(tabContent);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      ensureVideoModal();
      renderVideo();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wc-campaign-cove"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    let frame = 0;
    let visible = true;
    const render = () => {
      frame = 0;
      const stage = root.firstElementChild;
      const distance = Math.max(1, root.offsetHeight - stage.offsetHeight);
      const progress = motion.matches ? 0 : Math.min(1, Math.max(0, -root.getBoundingClientRect().top / distance));
      root.style.setProperty('--cove-progress', progress.toFixed(4));
    };
    const schedule = () => { if (visible && !frame) frame = requestAnimationFrame(render); };
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; if (visible) schedule(); });
    observer.observe(root);
    window.addEventListener('scroll', schedule, {passive:true, signal:controller.signal});
    window.addEventListener('resize', schedule, {passive:true, signal:controller.signal});
    motion.addEventListener('change', schedule, {signal:controller.signal});
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) { controller.abort(); observer.disconnect(); cancelAnimationFrame(frame); }
    }, {signal:controller.signal});
    render();
  };
  const initializeAll = scope => scope.querySelectorAll('[data-wc-cove]').forEach(initialize);
  initializeAll(document);
  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wc-quiet-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = root => root.querySelectorAll('[data-wc-slider]').forEach(slider => {
  if (slider.dataset.initialized) return;
  slider.dataset.initialized = 'true';
  const slides=[...slider.querySelectorAll('[data-slide]')], dots=[...slider.querySelectorAll('[data-dot]')];
  if(slides.length<2) return;
  let current=0,timer,startX=0;
  const show=i=>{
   current=(i+slides.length)%slides.length;
   slides.forEach((s,n)=>{const active=n===current;s.classList.toggle('is-active',active);s.setAttribute('aria-hidden',String(!active));});
   dots.forEach((d,n)=>{const active=n===current;d.classList.toggle('is-active',active);d.setAttribute('aria-current',String(active));});
  };
  const stop=()=>clearInterval(timer);
  const play=()=>{stop();if(!matchMedia('(prefers-reduced-motion: reduce)').matches)timer=setInterval(()=>show(current+1),Number(slider.dataset.delay)||8000);};
  slider.querySelector('[data-prev]')?.addEventListener('click',()=>{show(current-1);play()});
  slider.querySelector('[data-next]')?.addEventListener('click',()=>{show(current+1);play()});
  dots.forEach(d=>d.addEventListener('click',()=>{show(Number(d.dataset.dot));play()}));
  slider.addEventListener('mouseenter',stop);slider.addEventListener('mouseleave',play);
  slider.addEventListener('focusin',stop);slider.addEventListener('focusout',play);
  slider.addEventListener('touchstart',e=>startX=e.touches[0].clientX,{passive:true});
  slider.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-startX;if(Math.abs(dx)>45){show(current+(dx<0?1:-1));play()}},{passive:true});
  document.addEventListener('visibilitychange',()=>document.hidden?stop():play());
  play();
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
 document.addEventListener('shopify:section:load',e=>init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wc-scroll-drop"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wc-door-breakout')) {
  customElements.define('wc-door-breakout', class extends HTMLElement {
    connectedCallback(){
      if(this.cleanup)return;
      const root=this;
      const stage=this.querySelector('.wc-breakout__stage');
      const pieces=[...this.querySelectorAll('.wc-breakout__piece')];
      const motion=matchMedia('(prefers-reduced-motion: reduce)');
      const clamp=x=>Math.max(0,Math.min(1,x));
      const ease=(a,b,p)=>{
        const x=clamp((p-a)/(b-a));
        return x*x*(3-2*x);
      };
      let frame=0,active=true,width=0,height=0,distance=1;

      const measure=()=>{
        width=root.clientWidth;
        height=stage.offsetHeight;
        distance=Math.max(1,root.offsetHeight-height);
      };

      const render=()=>{
        frame=0;
        const p=motion.matches?1:clamp(-root.getBoundingClientRect().top/distance);

        const zoom=ease(.03,.34,p);
        const door=ease(.16,.47,p);
        const escape=ease(.40,.63,p);
        const products=ease(.58,.82,p);
        const copy=ease(.79,.92,p);

        root.style.setProperty('--progress',p);
        root.style.setProperty('--office-scale',1+zoom*1.55);
        root.style.setProperty('--office-opacity',1-escape);
        root.style.setProperty('--door-angle',(-103*door)+'deg');
        root.style.setProperty('--portal-opacity',ease(.12,.26,p));
        root.style.setProperty('--weekend-scale',1.12-escape*.12);
        root.style.setProperty('--products',products);
        root.style.setProperty('--shade-opacity',.22+products*.78);
        root.style.setProperty('--copy',copy);
        root.style.setProperty('--type-scale',.86+products*.14);
        root.style.setProperty('--opening-opacity',1-ease(.035,.20,p));
        root.style.setProperty('--opening-y',(-zoom*40)+'px');
        root.style.setProperty('--copy-y',((1-copy)*24)+'px');
        root.style.setProperty('--product-pointer',products>.96?'auto':'none');

        pieces.forEach((el,i)=>{
          const sign=i===0?-1:1;
          const spread=width*(width<750?.22:.19)*products;
          const y=(1-products)*height*.34;
          el.style.transform=`translate(-50%,-50%) translate3d(${sign*spread}px,${y}px,0) rotate(${sign*(18*(1-products)+3)}deg) scale(${.24+products*.76})`;
          el.tabIndex=products>.96?0:-1;
          el.setAttribute('aria-hidden',products>.96?'false':'true');
        });
      };

      const schedule=()=>{if(active&&!frame)frame=requestAnimationFrame(render)};
      const resize=()=>{measure();schedule()};
      const observer=new IntersectionObserver(entries=>{
        active=entries[0].isIntersecting;
        if(active){measure();schedule()}
      },{rootMargin:'200px'});

      observer.observe(root);
      addEventListener('scroll',schedule,{passive:true});
      addEventListener('resize',resize,{passive:true});
      addEventListener('pageshow',resize);
      motion.addEventListener('change',resize);
      measure();
      render();

      this.cleanup=()=>{
        cancelAnimationFrame(frame);
        observer.disconnect();
        removeEventListener('scroll',schedule);
        removeEventListener('resize',resize);
        removeEventListener('pageshow',resize);
        motion.removeEventListener('change',resize);
        this.cleanup=null;
      };
    }
    disconnectedCallback(){this.cleanup?.()}
  });
}

  } catch(e) { console.error(e); }
})();
})();
